import React from 'react';
import {Link} from 'react-router-dom'
import MenuItem from 'material-ui/MenuItem';
import Drawer from 'material-ui/Drawer';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import logo from '../../img/loomis-logo.svg';
import {LoomisColors} from '../../lib/LoomisColors';
import customerIcon from '../../img/customer.svg';
import CurrentUser from '../currentUser/CurrentUser';
import translate from '../../lib/i18n/translate'

import './Header.css';
import {USER_ROLES} from "../../store/reducers/user";

const iconStyles = {
    color: '#ffffff',
};

const drawerStyle = {
    backgroundColor: '#577079',
};

const overlayStyle = {
    backgroundColor: LoomisColors.darkerBlue,
    opacity: 0.64,
};

const closeMenuStyle = {
    float: 'right',
};

const Header = (props) => {
    const {Dashboard, SwitchCustomer, MyProfile, Logout, Report} = props.strings;

    return (
        <div>
            <div className="topBar">
                <IconButton
                    className="topIcon"
                    onTouchTap={props.toggleMenu}
                    iconStyle={iconStyles}
                >
                    <FontIcon className="material-icons">menu</FontIcon>
                </IconButton>
                <div className="logoWrapper">
                   <Link to="/"><img className="headerLogo" style={{borderStyle:'none'}} src={logo} alt="Loomis"/></Link>
                </div>

                <Link to="/profile"><IconButton
                    className="accountIcon topIcon"
                    iconStyle={iconStyles}
                >
                    <FontIcon className="material-icons">account_circle</FontIcon>
                </IconButton>
                </Link>
                <CurrentUser/>
            </div>

            <Drawer open={props.open} overlayStyle={overlayStyle} containerStyle={drawerStyle} docked={false}>
                <div className="menuTitle">
                    <IconButton
                        className="topIcon"
                        style={closeMenuStyle}
                        iconStyle={iconStyles}
                        iconClassName="material-icons right"
                        onTouchTap={props.hideMenu}
                    >
                        close
                    </IconButton>
                    <div>SAFEPOINT</div>
                </div>
                <MenuItem
                    className="menuItemStyle"
                    containerElement={<Link to="/" />}
                    onTouchTap={props.hideMenu}
                    primaryText={Dashboard}
                    leftIcon={<FontIcon color={LoomisColors.white} className="material-icons">dashboard</FontIcon>}
                     />
                <MenuItem
                    className="menuItemStyle"
                    containerElement={<Link to="/customers" />}
                    onTouchTap={props.hideMenu}
                    primaryText={SwitchCustomer}
                    leftIcon={<img src={customerIcon} alt="Customer Icon" className="svgIcon"/>}
                     />
                <MenuItem
                    className="menuItemStyle"
                    containerElement={<Link to="/profile"/>}
                    onTouchTap={props.hideMenu}
                    primaryText={MyProfile}
                    leftIcon={<FontIcon color={LoomisColors.white} className="material-icons">account_circle</FontIcon>}
                     />

                {props.authorities.includes(USER_ROLES.ROLE_REPORT) &&
                    <MenuItem
                        className="menuItemStyle"
                        containerElement={<Link to="/report"/>}
                        onTouchTap={props.hideMenu}
                        primaryText={Report}
                        leftIcon={<FontIcon color={LoomisColors.white} className="material-icons">assignment</FontIcon>}
                        />
                }
                <MenuItem
                    className="menuItemStyle"
                    onTouchTap={
                        ()=>{props.hideMenu(); props.logout()}
                    }
                    primaryText={Logout}
                    leftIcon={<FontIcon color={LoomisColors.white} className="material-icons">power_settings_new</FontIcon>}
                     />
            </Drawer>
        </div>
    );
};
export default translate('Drawer')(Header);




// WEBPACK FOOTER //
// ./src/components/header/Header.js